import React from 'react'
import {useSelector} from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

const PrivateRouteDashboard = () => {
    const userToken = useSelector(state=>state.userToken)

    // console.log(userToken)
  return (
    <div>
      {userToken?<Outlet/>:<Navigate to="/login"/>}
    </div>
  )
}

export default PrivateRouteDashboard
